<template>
  <div>
    <div
        v-if="detail_loader"
        style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 md12 lg7 mt-3>
          <v-card><h3 style="padding-left: 20px; padding-top: 10px">Incident Details</h3>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Id: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="id"
                        v-model="show_incident_object.id"
                        label="Id" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Incident name: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="incident_name"
                        v-model="show_incident_object.incidentTypeName"
                        label="Incident Name" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Description: </label>
                  </v-flex>

                  <v-flex xs12 md6 lg8 style="display: flex; flex-direction: column;">
                    <v-flex xs12 md12 lg12>
                      <v-textarea
                          name="Description"
                          v-model="show_incident_object.description"
                          rows="5"
                          label="Description" disabled
                          solo flat>
                      </v-textarea>
                    </v-flex>

                    <v-flex xs12 md12 lg12 style="display: flex; justify-content: flex-end;">
                      <v-flex xs12 sm3 style="margin-bottom: 23px; margin-top: -33px;">
                        <v-btn flat icon color="indigo" v-if="is_liked == 0" style="left: 50%;"
                               @click="likeIncident(show_incident_object.id)">
                          <v-icon>thumb_up</v-icon>
                        </v-btn>

                        <v-btn flat icon color="red" v-if="is_liked == 1" style="left: 50%;"
                               @click="likeIncident(show_incident_object.id)">
                          <v-icon>thumb_up</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-flex>


                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Station name: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="Station_name"
                        v-model="show_incident_object.stationName"
                        label="Station Name" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Publish Status: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="Publish_status"
                        v-model="show_incident_object.publish_status"
                        label="Publish Status" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Likes Count: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="Like_count"
                        v-model="show_incident_object.likes_count"
                        label="Like Count" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Created By: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="Description"
                        v-model="show_incident_object.full_name"
                        label="Incident Name" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

                <v-flex xs12 md12 lg12 style="display: flex;">
                  <v-flex xs12 md6 lg4>
                    <label>Affected Lines: </label>
                  </v-flex>
                  <v-flex xs12 md6 lg8>
                    <v-text-field
                        name="Affected_Lines"
                        v-model="show_incident_object.line_incidents_data"
                        label="Affected Lines" disabled
                        solo flat>
                    </v-text-field>
                  </v-flex>
                </v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md12 lg5 mt-3>
          <v-card><h3 style="padding-left: 20px; padding-top: 10px">Comments</h3>
            <v-card-text>
              <v-layout row wrap style="display: contents;">
                <v-sheet
                    class="pa-1"
                    color="grey lighten-3" v-if="comments.length > 0" style="border-radius: 10px">
                  <v-flex xs12 md12 lg12
                          v-for="user_comment in comments"
                          :key="user_comment">
                    <v-sheet :user_comment="user_comment" style="border-radius: 10px">
                      <v-flex xs12 sm12 md12 lg12 row style="display: flex;align-items: center; margin-bottom: -20px;">
                        <v-flex sm2 md2 lg2>
                          <v-avatar size="36px">
                            <img
                                v-if="user_comment.profile_pic"
                                src="https://avatars0.githubusercontent.com/u/9064066?v=4&s=460"
                                alt="Avatar">
                          </v-avatar>
                        </v-flex>

                        <v-flex xs8 sm8 md8 lg8>
                              <span v-if="user_comment.id" :key="user_comment.id">
                                <b>{{ user_comment.user_first_name }} {{ " " }}{{ user_comment.user_last_name }}</b>
                              </span>
                        </v-flex>

                        <v-flex sm2 md2 lg2>
                          <v-btn flat icon small color="red" style="left: 35%;"
                          @click="delete_comment_dialog = true; comment_id=user_comment.id;">
<!--                                 @click="deleteIncidentComment(user_comment.id)">-->
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-flex>

                      <v-flex xs12 sm12 md12 lg12 row style="display: flex;">
                        <v-flex sm2 md2 lg2>
                          <v-avatar size="36px">
                          </v-avatar>
                        </v-flex>

                        <v-flex xs10 sm10 md10 lg10>
                          <v-flex xs12 sm12 md12 lg12>
                            {{ user_comment.comment }}
                          </v-flex>

                          <v-flex xs12 sm12 md12 lg12 style="float: inline-end; color: grey">
                            {{ "~Posted On: (" }} {{ moment(user_comment.updated_at).format("D MMM y H:m a") }}{{
                              ")" }}
                          </v-flex>
                        </v-flex>

                      </v-flex>
<!--                        <v-flex xs8 sm10 md10 lg10>-->
<!--                          <v-flex xs12 sm12 md12 lg12>-->
<!--                              <span v-if="user_comment.id" :key="user_comment.id">-->
<!--                                <b>{{ user_comment.user_first_name }} {{ " " }}{{ user_comment.user_last_name }}</b>-->
<!--                              </span>-->
<!--                            <v-btn flat icon small color="indigo" style="left: 60%;"-->
<!--                                   @click="deleteIncidentComment(user_comment.id)">-->
<!--                              <v-icon>delete</v-icon>-->
<!--                            </v-btn>-->
<!--                          </v-flex>-->

<!--                          <v-flex xs12 sm12 md12 lg12>-->
<!--                            {{ user_comment.comment }}-->
<!--                          </v-flex>-->


<!--                        </v-flex>-->


                    </v-sheet>
                  </v-flex>
                </v-sheet>
                <v-sheet v-else>
                  <v-subheader>No comments on this Incident...</v-subheader>
                </v-sheet>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>


      <v-dialog v-model="delete_comment_dialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Confirm Delete</v-card-title>
          <v-card-text>Are you sure you wants to delete the Incident Comment?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="danger" flat @click="delete_comment_dialog = false">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click="deleteIncidentComment(comment_id)">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Resource dialog box -->
      <v-snackbar
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          v-model="snackbar.show"
      >
        {{ snackbar.message }}
        <v-btn dark flat @click.native="snackbar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Detail",

  data: () => {
    return {
      show_incident_object: [],
      comments: [],
      is_liked: 0,
      delete_comment_dialog: false,
      detail_loader: false,
      comment_id: "",
      snackbar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
    };
  },
  methods: {
    activateShowDialog() {
      this.startLoading();
      this.is_liked = 0;
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-incident/` + this.$route.params.id, {
        headers: this.$headers,
      }).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.show_incident_object = response.data.data;
          this.show_incident_object.full_name = this.show_incident_object.created_by_user.first_name + ' ' +
              this.show_incident_object.created_by_user.last_name;
          let line_array = [];
          this.show_incident_object.line_incidents.forEach((element) => {
            if (element.line_id == 1) {
              line_array.push("Central");
            } else if (element.line_id == 2) {
              line_array.push("Western");
            } else if (element.line_id == 3) {
              line_array.push("Harbour");
            } else if (element.line_id == 4) {
              line_array.push("Trans Harbour");
            } else if (element.line_id == 5) {
              line_array.push("Uran");
            } else if (element.line_id == 6) {
              line_array.push("Panvel-Vasai");
            } else if (element.line_id == 7) {
              line_array.push("Neral-Matheran");
            } else if (element.line_id == 8) {
              line_array.push("Pune-Lonavla");
            }
          });

          this.show_incident_object.line_incidents_data = line_array.join(', ');
          this.show_incident_object.incidentTypeName = this.show_incident_object.incident_type.name;
          this.show_incident_object.stationName = this.show_incident_object.station_name.name;
          if (this.show_incident_object.incident_likes.length > 0) {
            this.is_liked = 1;
          } else {
            this.is_liked = 0;
          }
          this.showIncidentDetailDialog = true;
        } else if (response.data.status == 0) {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.stopLoading();
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true;
      });
    },
    likeIncident(id) {
      let formData = new FormData();
      formData.append('incident_id', id);
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/web-incident-add-like`, formData,
          {headers: this.$headers,})
          .then(response => {
            if (response.data.status == 1) {
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
              this.activateShowDialog(id);
            } else if (response.data.status == 0) {
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;

            }
          });
    },
    getComments() {
      let formData = new FormData();
      formData.append('incident_id', this.$route.params.id);
      this.comments = [];
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-incident-comments`,
          {
            headers: this.$headers, params: {
              incident_id: this.$route.params.id
            }
          })
          .then(response => {
            if (response.data.status == 1) {
              this.comments = response.data.data;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            } else if (response.data.status == 0) {
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;

            }
          });
    },
    deleteIncidentComment(id) {
      console.warn(id);
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-incident-comment`,
          {incident_comment_id: id}, {headers: this.$headers}).then((response) => {
            console.warn(response);
        if (response.data.status == 1) {
          this.delete_comment_dialog = false;
          this.comment_id = '';
          this.getComments();
          this.stopLoading();
          this.snackbar.display = true;
          this.snackbar.message = response.data.message;
        } else {
          this.snackbar.display = true;
          this.snackbar.message = response.data.message;
        }
      });
    }
  },
  mounted() {
    this.activateShowDialog();
    this.getComments();
  },
};
</script>


